import { IconImageOutline18 as ImageIcon } from "nucleo-ui-outline-18"

import { ConnectorLogo } from "@/components/connector-logo"
import { api } from "@/lib/api"

// Fetched on the server: the browser cannot read another origin's markup, and
// the address is user-supplied so it has to clear the SSRF guard first.
export function LinkPreviewCard({ url }: { url: string }) {
	const { data, isLoading } = api.linkPreview.get.useQuery(
		{ url },
		{
			enabled: Boolean(url),
			staleTime: 5 * 60 * 1000,
			retry: false,
			refetchOnWindowFocus: false,
		},
	)

	if (isLoading) {
		return (
			<div className="h-[200px] w-full animate-pulse rounded-lg bg-gray-100 dark:bg-gray-850" />
		)
	}

	const hasAnything = data?.imageUrl || data?.title || data?.description
	if (!hasAnything) {
		return (
			<div className="flex h-[120px] w-full flex-col items-center justify-center gap-2 rounded-lg bg-gray-50 text-tertiary ring-1 ring-black/5 dark:bg-gray-850 dark:ring-white/10">
				<ImageIcon className="h-4 w-4 flex-none" />
				<span className="text-xs">This page has no preview image</span>
			</div>
		)
	}

	return (
		<div className="overflow-hidden rounded-lg bg-gray-50 ring-1 ring-black/5 dark:bg-gray-850 dark:ring-white/10">
			{data?.imageUrl && (
				<img
					src={data.imageUrl}
					alt=""
					className="aspect-[1200/630] w-full object-cover"
					loading="lazy"
				/>
			)}
			<div className="flex items-start gap-2.5 px-3.5 py-3">
				<ConnectorLogo url={url} sizeClassName="mt-0.5 h-4 w-4" />
				<div className="min-w-0 flex-1">
					{data?.title && (
						<p className="line-clamp-1 text-[13px] font-medium text-primary">
							{data.title}
						</p>
					)}
					{data?.description && (
						<p className="mt-0.5 line-clamp-2 text-xs text-tertiary">
							{data.description}
						</p>
					)}
				</div>
			</div>
		</div>
	)
}
